module.exports = __webpack_public_path__ + "img/Frame16.9913c3cc.png";